export default {
  name: "Restaurant",
  plural: "Restaurants",
};
